import React, {Component} from 'react';
import Styles from './style.css';
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {dataRegister} from "../../services/dataRegister";
import UserCampaignHistoryItem from "../user-campaigns-history-item/component"

class userBillingPayment extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    };

    componentWillMount() {

    }

    render() {
        return (
            <div>
                <div className={Styles.container}>

                </div>
            </div>
        );
    }
}

export default userBillingPayment;


// WEBPACK FOOTER //
// ./src/components/user-billing-payment/component.js